import api from "../utils/axios";
import { getUserRoleFromToken } from "../utils/Auth";
import { userRoles } from "../types/enums";

const RESTRICTED_ROLES: number[] = [userRoles.CLIENT, userRoles.SUBCLIENT];

export const canFetchAllUsers = (): boolean => {
	const role = getUserRoleFromToken();
	if (role === false) return false;
	return !RESTRICTED_ROLES.includes(role as number);
};

export const fetchAllUsers = async (): Promise<any[] | null> => {
	if (!canFetchAllUsers()) return null;
	try {
		const response = await api.get("User");
		if (response.status === 200 && response.data) {
			return response.data;
		}
		return null;
	} catch (error) {
		console.error("Error fetching users:", error);
		return null;
	}
};
